import { Heading, Stack, RadioGroup, Inline, Checkbox, ValidationMessage, textVariants, Text } from '@etg/wings';
import { Pictogram } from '@eti/components';
import { useTranslation, useSiteContext, useValidation } from '@eti/providers';
import { Field as ReduxFormField } from 'redux-form';
import { getUniqFeatures } from '../../utils/utils';
import { screenReaderOnly } from '../../../common/utils/styles';
import MobileOption from './MobileOption';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const RadioGroupComponent = _ref => {
  let {
    discountPercentageTitle,
    emptyOptionId,
    emptyOptionTitle,
    footerWrapperStyles,
    handleChange,
    handleModalOpen,
    input,
    isOpen,
    meta,
    name,
    priceText,
    sellableOptions,
    shouldShowPricePerPerson,
    travelers
  } = _ref;
  const {
    brand: {
      code: brand
    }
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const uniqFeatures = getUniqFeatures(sellableOptions);
  const hasError = Boolean(meta.touched && meta.error) || Boolean(meta.touched && input.value === undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Inline, {
      noWrap: true,
      spacing: 16,
      children: [/*#__PURE__*/_jsx(Pictogram, {
        "aria-hidden": "true",
        brand: brand,
        id: "ancillary-bundle",
        size: "32px"
      }), /*#__PURE__*/_jsx(Heading, {
        level: 2,
        children: t('Product.FlexibleTicket.Bundle.Title')
      })]
    }), /*#__PURE__*/_jsx(Text, {
      "aria-hidden": "true",
      variant: textVariants._16,
      children: discountPercentageTitle
    }), /*#__PURE__*/_jsxs(RadioGroup, {
      hasError: hasError,
      name: name,
      onChange: handleChange,
      selectedValue: input.value,
      children: [/*#__PURE__*/_jsx(RadioGroup.Legend, {
        className: screenReaderOnly,
        children: `${discountPercentageTitle} ${t('Product.Bundle.SelectOne.Label.required')} ${t('Validation.Required')}`
      }), /*#__PURE__*/_jsx(Stack, {
        spacing: 8,
        children: sellableOptions.map(option => /*#__PURE__*/_jsx(MobileOption, {
          handleModalOpen: handleModalOpen,
          isOpen: isOpen,
          name: name,
          numberOfTravelers: travelers.filter(traveler => traveler.ageType !== 'INF').length,
          option: option,
          priceText: priceText,
          shouldShowPricePerPerson: shouldShowPricePerPerson,
          uniqFeatures: uniqFeatures
        }, option.id))
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      className: footerWrapperStyles,
      noWrap: true,
      children: [/*#__PURE__*/_jsxs(Checkbox.Label, {
        htmlFor: `choice.${name}.${emptyOptionId}`,
        children: [emptyOptionTitle, /*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: t('ScreenReader.Product.Bundle.Empty.Option.Text')
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        "aria-checked": Boolean(input.value === emptyOptionId),
        checked: input.value === emptyOptionId,
        "data-testid": `productBundleItem-${emptyOptionId}`,
        id: `choice.${name}.${emptyOptionId}`,
        onChange: handleChange,
        value: emptyOptionId
      })]
    }), hasError && /*#__PURE__*/_jsx(ValidationMessage, {
      "aria-labelledby": "ancillaryBundle-validation-message-text",
      "data-testid": "ancillaryBundle-validation-message",
      variant: "error",
      children: /*#__PURE__*/_jsx(Text, {
        "aria-live": "assertive",
        id: "ancillaryBundle-validation-message-text",
        children: t('Validation.ProductSection.SelectOption')
      })
    })]
  });
};
const hasBeenSelected = value => value !== null && value !== undefined;
const MobileBundle = _ref2 => {
  let {
    name,
    ...props
  } = _ref2;
  const validate = useValidation(name);
  const format = value => hasBeenSelected(value === null || value === void 0 ? void 0 : value.value) ? value === null || value === void 0 ? void 0 : value.value.id : undefined;
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: RadioGroupComponent,
    format: format,
    name: name,
    props: {
      ...props,
      name
    },
    validate: validate
  });
};
export default MobileBundle;
//# sourceMappingURL=MobileBundle.js.map